export default __webpack_public_path__ + "static/media/Asset 10.2d1a0124.png";